import styled from 'styled-components';
import { Colors } from 'axl-reactjs-ui';

export const MainContainer = styled.div`
  display: flex;
  height: calc(100vh - 100px);
  flex-direction: row;
  align-items: center;
  max-width: 1600px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0px;
  margin-bottom: 0px;
  @media(max-width: 1199px) {
    width: 100%;
    overflow-x: scroll;
  }
`;

export const LeftPanel = styled.div`
  min-width: 300px;
  background-color: #fff;
  border-radius: 8px;
  width: 400px;
  height: 100%;
  margin-right: 10px;
`;

export const MiddlePanel = styled.div`
  min-width: 400px;
  width: 540px;
  border-radius: 8px;
  height: 100%;
`;

export const RightPanel = styled.div`
  min-width: 300px;
  width: calc(100% - 940px);
  border-radius: 8px;
  height: 100%;
`;

export default {
    container: {
        minHeight: '600px',
        position: 'relative',
        maxWidth: '1600px',
        margin: '0 auto'
    },
    overlay: {
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "rgba(0,0,0,0.2)",
        zIndex: 99,
    },
    mainContent: {
      height: '100%',
      display: 'flex'
    },
    topHeader: {
        textAlign: 'left',
        padding: '0px 10px 0 10px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row'
    },
    topHeaderLeft: {
        display: 'flex',
        flex: 1
    },
    topHeaderRight: {
        position: 'relative',
        zIndex: 999
    },
    panel: {
        height: '100%',
        padding: '10px',
        boxSizing: 'border-box',
    },
    innerBox: {
        height: '100%',
        backgroundColor: Colors.veryLightGrey,
        overflow: 'hidden',
        position: 'relative'
    },
    bottomBox: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: '325px',
        backgroundColor: '#fff',
        borderTop: 'solid 1px #ccc',
        zIndex: 1
    },
    boxContent: {
        position: 'absolute',
        top: '10px',
        left: '10px',
        right: '10px',
        bottom: '355px',
    },
    label: {
        display: 'inline-block',
        fontFamily: 'AvenirNext-Medium',
        fontSize: '18px',
        fontWeight: '500',
        color: '#3b3b3b',
        margin: '0 10px'
    },
    AxlPanelSliderStyle: {
        top: '-7px',
        position: 'absolute',
        height: '100vh',
        right: '-8px',
        paddingTop: 0
    }
}
